import { render } from "./examination.vue?vue&type=template&id=67b98fd7&scoped=true"
import script from "./examination.vue?vue&type=script&lang=js"
export * from "./examination.vue?vue&type=script&lang=js"

import "./examination.vue?vue&type=style&index=0&id=67b98fd7&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-67b98fd7"

export default script